/*
 * Jira Ticket:
 * Created Date: Tue, 2nd Jun 2020, 10:48:15 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

const onDrop = ({ acceptedFiles, setImgLoaded }) => {
  if (acceptedFiles && acceptedFiles.length === 0) {
    return;
  }

  acceptedFiles.forEach(file => {
    var image = new Image();
    image.addEventListener('load', () => {
      file.height = image.height; // pass on the image width and height, synchronous func so takes a while
      file.width = image.width;
      setImgLoaded(true); // let the ImageField rerender now that we have the image width and height
    });
    image.src = URL.createObjectURL(file);
  });
  return acceptedFiles;
};

export default onDrop;
